import { AttentionSignal } from './workspaceAttentionInbox';
import { WorkspaceTask } from '../store/api/workspaceApi';
import {
  buildScopedTaskPresentation,
  type ScopedTaskPresentation,
  type ScopedTaskPresentationContext,
} from './scopedTaskPresentation';

export type InboxRowPresentationMode = 'legacy' | 'scoped';

export type InboxTaskRowPresentation = {
  mode: InboxRowPresentationMode;
  primaryLine: string;
  secondaryLine: string;
  scopedLines?: string[];
  tooltip: string;
};

export { formatScopedTransportTypeLabel as formatInboxTransportTypeLabel } from './scopedTaskPresentation';

function toInboxPresentation(
  presentation: ScopedTaskPresentation,
  legacyEntityLabel: string
): InboxTaskRowPresentation {
  if (presentation.mode === 'scoped') {
    return {
      mode: 'scoped',
      primaryLine: presentation.lines[0] ?? presentation.titleLine,
      secondaryLine: presentation.titleLine,
      scopedLines: presentation.lines,
      tooltip: presentation.tooltip,
    };
  }

  return {
    mode: 'legacy',
    primaryLine: legacyEntityLabel,
    secondaryLine: presentation.titleLine,
    tooltip: `${legacyEntityLabel}\n${presentation.titleLine}`,
  };
}

/**
 * Inbox row copy for GROUP/STOP tasks when ROUTE_GROUP_DOCUMENT_WORKFLOW is ON.
 * Uses unified scoped task presentation builder.
 */
export function buildInboxTaskRowPresentation(
  signal: AttentionSignal,
  scopedInboxEnabled: boolean,
  context?: ScopedTaskPresentationContext
): InboxTaskRowPresentation {
  const legacyEntityLabel = String(signal.entityLabel || '—').trim() || '—';

  if (!scopedInboxEnabled || signal.source !== 'task' || signal.task == null) {
    const secondaryLine = String(signal.title || 'Задача').trim() || 'Задача';
    return {
      mode: 'legacy',
      primaryLine: legacyEntityLabel,
      secondaryLine,
      tooltip: `${legacyEntityLabel}\n${secondaryLine}`,
    };
  }

  return toInboxPresentation(
    buildScopedTaskPresentation(signal.task, {
      scopedEnabled: scopedInboxEnabled,
      context: {
        ...context,
        legacyEntityLabel,
      },
      titleOverride: signal.title,
      legacyEntityLabel,
    }),
    legacyEntityLabel
  );
}

/** @internal test helper */
export function inboxPresentationUsesLegacyTask(task: WorkspaceTask | null | undefined): boolean {
  if (task == null) return true;
  const scope = String(task.taskScope || 'ROUTE').toUpperCase();
  return scope === 'ROUTE';
}
